import React, {FC} from "react"
import Card from "@irati/ui/src/Layout/Card"
import {H3} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"

import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import Progress from "../Progress"

interface Props extends InjectIntl {
  activeStep: number
}

const RenewalsProgressBanner: FC<Props> = ({activeStep, formatMessage}) => {
  const data = [
    {
      title: "admin.billing.renewals.progressBanner.step1",
      completed: activeStep > 1,
      active: activeStep === 1
    },
    {
      title: "admin.billing.renewals.progressBanner.step2",
      completed: activeStep > 2,
      active: activeStep === 2
    },
    {
      title: "admin.billing.renewals.progressBanner.step3",
      completed: false,
      active: activeStep === 3
    }
  ]
  const theme = useTheme()
  return (
    <Card bgColor={theme.colors.greys.lightest} marginBottom={3}>
      <Flex gap={theme.spacing.two}>
        <img
          src={formatMessage({
            id: "admin.billing.renewals.progressBanner.img"
          })}
        />
        <div>
          <H3 marginBottom={1}>
            <FormattedMessage id="admin.billing.renewals.progressBanner.title" />
          </H3>
          <Progress progress={data} small inline />
        </div>
      </Flex>
    </Card>
  )
}

export default injectIntl(RenewalsProgressBanner)
